import React from 'react'
import '../styles/pageStyles/MyChannel.scss'
import MyChannelLanding from '../components/MyChannel/MyChannelLanding'

const MyChannel = () => {
    return (
        <div className='my-channel'>
            <MyChannelLanding />
        </div>
    )
}

export default MyChannel